import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { EdpUser } from "@edp-models/user.model";
import { NewModalService } from "@edp-pages/requests-and-operations/services/new-modal.service";
import { EdpPaymentAgreementService } from "@edp-services/edp-payment-agreement.service";
import { getUser } from "@edp-store/selectors/user.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "no-agreement-proposal",
    templateUrl: "./no-agreement-proposal.component.html",
    styleUrls: ["./no-agreement-proposal.component.scss"],
})
export class NoAgreementProposalComponent {
    public isPage: boolean;
    public ineligibleClient: boolean;
    public user: EdpUser;

    constructor(
        private edpPaymentAgreementService: EdpPaymentAgreementService,
        private readonly translateService: TranslateService,
        private readonly modalService: NewModalService,
        private store: Store<IAppState>,
        private router: Router
    ) {
        this.isPage = this.edpPaymentAgreementService.getBottomBarValue();
        this.ineligibleClient = this.edpPaymentAgreementService.getIneligibleClient();

        this.store.select(getUser).subscribe(user => {
            this.user = user;
        });
    }

    public close() {
        if (this.user) {
            this.goToRequestAndOperations();
        } else {
            this.goToExternalUrl();
        }
    }
    
    public goToRequestAndOperations() {
        if (this.isPage) {
            this.modalService.closeModal();
        } else {
            return this.router.navigate(["/pedidos-apoio"]);
        }
    }

    public goToExternalUrl() {
        const url = this.translateService.instant("pt.edp.edponline.payment.agreement.url.edp");
        window.location.href = url;
    }
}
